import ReactModal from "react-modal";
var OrderDeliveryOption = require('../General/DeliveryOption').DeliveryOption;
import { AbconetApi } from '../General/AbconetApi';
import { isNullOrUndefined } from 'util';

export class CartCreateButton extends React.Component {
    constructor(props) {
        super();
        this.state = {
            isCreating: false,
            isCreated: false,
            modalOpen: false,
            cart: {

            }
        }
    }

    openModal() {
        this.setState({
            modalOpen: true
        });
    }

    closeModal() {
        this.setState({
            modalOpen: false
        });
    }

    setDeliveryOption(deliveryOption) {
        var currentCart = this.state.cart;

        if (deliveryOption.deliveryType == "PICK-UP") {
            currentCart.pickupLocation = deliveryOption.pickupLocation;
            currentCart.address = deliveryOption.address;
        } else {
            currentCart.pickupLocation = null;
            currentCart.address = deliveryOption.address;
        }

        this.setState({
            cart: currentCart
        });
    }

    createCart() {
        this.setState({ isCreating: true });


        AbconetApi.post('/api/cart', this.state.cart).then(
            (cart) => {
                setTimeout(
                    () => {
                        this.setState({ isCreated: true, isCreating: false });

                        setTimeout(() => {
                            window.location = "/cart/" + cart.id;
                        },
                            300);
                    },
                    200);
            });
    
    }

    renderCreateButton() {
        var btnText = 'Create Order';
        var btnClass = 'changes';
        if (this.state.isCreated) {
            btnText = 'Created';
            btnClass = 'saved';
        }

        if (this.state.isCreating) {
            btnText = 'Creating Order';
            btnClass = 'saving';
        }

        return <button className={"btn btn-primary float-right mt-4 " + btnClass} disabled={this.state.isCreated || this.state.isCreating} onClick={this.createCart.bind(this)}>{btnText}</button>;
    }

    render() {
        if (this.props.currentUser && this.props.currentUser.isTemplaCustomer && !isNullOrUndefined(this.props.punchoutData)) {
            return null;
        }

        return <div>
            <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.closeModal.bind(this)} portalClassName="modal-portal" className="modal-dialog" overlayClassName="modal" bodyOpenClassName="modal-open" >
               <div className="modal-content">
                   <div className="bd p-15">
                       <h5 className="m-0">Create Order</h5>
                   </div>
                    <div className="mt-4">
                        <OrderDeliveryOption cart={this.state.cart} onChange={this.setDeliveryOption.bind(this)} hideSummary={true} showManageSites={false} oneColumn={true} showCreateNew={true} extraButton={this.renderCreateButton()} />
                   </div>
                    <button onClick={this.closeModal.bind(this)} className="close"><span aria-hidden="true">&times;</span></button>
               </div>
           </ReactModal>
                <a href="#" className="btn btn-secondary cart-create" onClick={this.openModal.bind(this)}>
                   Create Order
               </a>
            </div>;
    }
}